export const GWUL_GROUP_NAME = "Greater Washington Urban League";
export const MAX_RECORDING_TIME_SECONDS = 10800;
export const MAX_POILING_TIME_OUT = 2 * 60 * 1000;

// Polling intervals (in milliseconds)
export const POLLING_INTERVAL_SESSION_INSIGHTS = 20000;
export const POLLING_INTERVAL_TREATMENT_PLAN = 20000;
export const POLLING_INTERVAL_AUDIO_STATUS = 20000;
export const POLLING_INTERVAL_PROCEDURAL_CODING = 20000;
export const POLLING_INTERVAL_DIAGNOSTIC_CODING = 20000;
export const LLT_GROUP_NAME = "Language Link Therapy";

// localStorage keys
export const RECORDING_WITH_HEADPHONES = "RECORDING_WITH_HEADPHONES";

export const INTERCOM_APP_ID = "lzzsoyz4";

export const IS_PROD = process.env.REACT_APP_SERVER_TYPE === "prod";

export const STRIPE_BILLING_PORTAL_URL = IS_PROD
  ? "https://billing.stripe.com/p/login/cN2eXjg2daCP5hKdQQ"
  : "https://billing.stripe.com/p/login/test_fZe2aI9KP5Dg6xWcMM";

export const RECORDER_TIMESLICE_MS_GCS = 10000;

export const RECORDER_AUDIO_BITRATE_BPS_GCS = 256000;

export const LC_KEYS = {
  CPT_CODE: "cpt_code",
  NOTE_TYPE: "note_type",
  LOCATION_TYPE: "location_type",
  DURATION_TYPE: "duration_type",
  IS_TEMPLATE: "is_template",
  RECORD_FIRST_INTRO_SEEN: "record_first_intro_seen",
  // Quick Start: the appointment whose suggestion was dismissed (×), per user and clinic day.
  QUICK_START_DISMISSED: "quick_start_dismissed",
  PREFERRED_MIC: "preferred_microphone",
  HIDE_EXTENSION_BANNER: "hide_extension_banner",
  HIDE_IOS_APP_BANNER: "hide_ios_app_banner",
  // Admin "login as user" (GOD mode) session metadata. Lives in LC_KEYS so
  // clearSessionAndRedirect() wipes it together with the token.
  IMPERSONATION: "impersonation_session",
};

export const IOS_APP_STORE_URL = "https://apps.apple.com/us/app/nudge-ai/id6466363218";

export const PURGE_EXPIRED_AUDIO_FILES_DAYS = 7;

export const USE_INDEXEDDB_BACKUP = process.env.REACT_APP_USE_INDEXEDDB_BACKUP === "true";

export const VALIDATION_TIME_SECONDS = 20;

export const NOTES_PAGE_SIZE = 20;
